// Montserrat est auto-hébergée par `@fontsource/montserrat` : aucune requête
// vers fonts.googleapis.com, donc aucune adresse IP d'administrateur envoyée
// à un tiers, et une admin qui reste utilisable sans accès Internet sortant.
// Les icônes suivent la même règle, via `@mui/icons-material` (des SVG
// embarqués dans le bundle, jamais une police d'icônes distante).
//
// Le sous-ensemble « latin » couvre é, è, ê, à, ù, ç, ô, î, ï, ë ;
// « latin-ext » ajoute les ligatures œ / Œ de « cœur », « sœur », « œuvre ».
import "@fontsource/montserrat/latin-400.css";
import "@fontsource/montserrat/latin-500.css";
import "@fontsource/montserrat/latin-700.css";
import "@fontsource/montserrat/latin-ext-400.css";
import "@fontsource/montserrat/latin-ext-700.css";
import { createTheme } from "@mui/material/styles";

/** Bleu nuit de la charte. */
export const BLEU_NUIT = "#1B263B";

/** Or de la charte. */
export const OR = "#D4AF37";

/**
 * L'or ne porte jamais de texte blanc : le contraste tomberait à 2,1:1, très
 * loin des 4,5:1 exigés par le WCAG AA. Le bleu nuit sur or dépasse 7:1.
 */
export const theme = createTheme({
  palette: {
    mode: "light",
    primary: {
      main: BLEU_NUIT,
      light: "#3C4C6B",
      dark: "#0E1523",
      contrastText: "#FFFFFF",
    },
    secondary: {
      main: OR,
      light: "#E4C86B",
      dark: "#9C7F1E",
      contrastText: BLEU_NUIT,
    },
    background: {
      default: "#F5F6F8",
      paper: "#FFFFFF",
    },
    text: {
      primary: BLEU_NUIT,
      secondary: "#4A5568",
    },
  },

  typography: {
    fontFamily: ["Montserrat", "system-ui", "-apple-system", "Segoe UI", "sans-serif"].join(","),
    fontWeightRegular: 400,
    fontWeightMedium: 500,
    fontWeightBold: 700,
    h1: { fontSize: "2rem", fontWeight: 700 },
    h2: { fontSize: "1.5rem", fontWeight: 700 },
    h3: { fontSize: "1.25rem", fontWeight: 700 },
    h4: { fontSize: "1.125rem", fontWeight: 500 },
    button: { textTransform: "none", fontWeight: 500 },
  },

  shape: { borderRadius: 8 },

  components: {
    MuiCssBaseline: {
      styleOverrides: {
        // Un contour visible au clavier, et seulement au clavier : l'admin se
        // parcourt à la tabulation autant qu'à la souris.
        ":focus-visible": {
          outline: `3px solid ${OR}`,
          outlineOffset: "2px",
        },
      },
    },
    MuiButton: {
      defaultProps: { disableElevation: true },
    },
  },
});
